export const replacePathParam = (paramName, value, path) =>
  // eslint-disable-next-line no-useless-escape,implicit-arrow-linebreak
  path.replace(new RegExp(`{${paramName}}`, 'g'), () => value);

export default {
  replacePathParam,
};
